export const isBrowserTabActive = () => document.visibilityState === 'visible'
